module.exports = {"620622100":"古浪镇","620622101":"泗水镇","620622102":"土门镇","620622103":"大靖镇","620622104":"裴家营镇","620622105":"海子滩镇","620622106":"定宁镇","620622107":"黄羊川镇","620622108":"黑松驿镇","620622109":"永丰滩镇","620622110":"黄花滩镇","620622111":"西靖镇","620622203":"民权乡","620622204":"直滩乡","620622205":"新堡乡","620622206":"干城乡","620622207":"横梁乡","620622208":"十八里堡乡","620622209":"古丰乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620622.json
// module id = 2704
// module chunks = 0